module.exports = __webpack_public_path__ + "static/media/OSMB02.797ef694.jpg";